<!--suppress ALL -->
<template>
  <div class="vacancies-result">
    <div class="vacancies-result__header">
      <!--      {{categories}} | {{selectedFilters}}-->
      <h1 v-if="isNoVacancies"
          class="vacancies-result__title">
        {{ $tVacancies('Vacancies not found') }}
      </h1>
      <h1 v-else-if="isCompanyVacancies"
          class="vacancies-result__title">
        {{ $tVacancies('Comapny vacancies') }}
      </h1>
      <!--      <h1 v-else-if="selectedDirection" class="vacancies-result__title">-->
      <!--        {{selectedDirection.title}}</h1>-->
      <VacanciesResultTitle v-else class="vacancies-result__title"/>
      <FilterTags v-if="loaded"
                  class="vacancies-result__filter-tags"/>
      <div class="vacancies-result__row">
        <p v-if="pending" class="vacancies-result__result-text">
          {{ $tVacancies('Searching for your request') }}
        </p>
        <p v-else class="vacancies-result__result-text">
          {{ $tVacancies('According to your request found', total) }}
          <b>{{ total }} {{ $tVacancies('vacancies', total) }}</b></p>
        <template v-if="false">
          <Subscribe v-if="showSubscribe"
                     :queryParams="params"
                     :subscribed="subscribedObject"
                     class="vacancies-result__subscribe"/>
        </template>
      </div>
    </div>
    <div class="vacancies-result__filter" v-if="vacancies && vacancies.length">
      <div class="vacancies-result__select-group">
        <BaseSelect :value="currentSort"
                    :options="sortList"
                    :getOptionText="getOptionTextSort"
                    @input="onSortInput"
                    class="vacancies-result__select _filter _white _shadow-full"
        />
        <CurrencySelect class="vacancies-result__select  _mob-last  _currency  _white _shadow-full"/>
        <router-link-modified :to="{name: 'find-vacancy'}"
                              class="vacancies-result__find-work  base-btn  base-btn--green  d-xs-none">
          {{ $tVacancies('Find vacancy') }}
        </router-link-modified>
      </div>

      <router-link-modified :to="{name: 'find-vacancy'}"
                            class="vacancies-result__find-work  base-btn  base-btn--green  d-none  d-xs-flex">
        {{ $tVacancies('Find vacancy') }}
      </router-link-modified>
    </div>

    <div class="vacancies-result__list-wrap"
         id="vacancies-list">
      <BasePreloader v-if="pending"/>
      <p v-if="pending && (!vacancies || !vacancies.length)">{{ $tVacancies('Searching...') }}</p>
      <p v-else-if="(!vacancies || !vacancies.length) "
         class="vacancies-result__not-found">{{ $tVacancies('Vacancies not found') }}...</p>
      <div class="vacancies-result__list">
        <VacancyCardSmall v-for="(item, index) in vacancies"
                          :key="item.id"
                          :vacancy="item"
                          @bookmark="setVacancyProperty([index, 'in_bookmarks', $event])"
                          class="vacancies-result__list-item  _small"/>
      </div>
    </div>

    <Pagination v-if="pagesCount"
                :quantity="pagesCount"
                class="vacancies-result__pagination"/>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import FilterTags from "./FilterTags";
  import CurrencySelect from './CurrencySelect'
  // import VacancyCard from "./vacancy-card/VacancyCard";
  import VacancyCardSmall from "./vacancyCardSmall/VacancyCardSmall";
  import Pagination from "./Pagination";
  import Subscribe from "./Subscribe";
  import VacanciesResultTitle from "./VacanciesResultTitle";
  import {EMPLOYEE, PARTNER} from '../constants/usersTypes'

  const sortList = ['recommended', 'salary', 'date']

  export default {
    name: "VacanciesResult",
    components: {
      // VacancyCard,
      VacancyCardSmall,
      FilterTags,
      CurrencySelect,
      Pagination,
      Subscribe,
      VacanciesResultTitle,
    },
    data() {
      return {
        timer: null,
        cancel: null,
        filterCheckbox: {
          value: false
        },
        sortList,
        queryNamePage: 'page',
      }
    },
    computed: {
      ...mapState('vacancies', [
        'loaded',
        'pending',
        'vacancies',
        'perPage',
        'total',
        'profession',
        'otherKeys',
        'subscribed',
      ]),
      ...mapGetters('vacancies', [
        'params',
      ]),
      currentSort() {
        return this.$route.query[this.otherKeys.SORT] || this.sortList[0]
      },
      currentDirectVacancy() {
        return this.$route.query['direct_vacancies'] === 'true' || this.$route.query['direct_vacancies'] === true
      },
      selectedCategoriesName() {
        return this.profession
          ? this.profession.category.title
          : null
      },
      page() {
        return this.$route.query[this.queryNamePage] || 1
      },
      pagesCount() {
        return Math.ceil((this.total || 0) / this.perPage) || 0
      },


      isCompanyVacancies() {
        return !!this.$route.query.customer_id
      },
      isNoVacancies() {
        return !this.pending && (!this.vacancies.length || !this.total)
      },
      showSubscribe() {
        const userType = this.$store.state.user.profile && this.$store.state.user.profile.user_type

        return userType && (userType === EMPLOYEE || userType === PARTNER)
      },
      subscribedObject() {

        return {
          telegram: !!this.subscribed
        }
      }
    },
    watch: {
      loaded(value) {
        if (value) this.$emit('loadend');
      },
    },
    methods: {
      ...mapMutations('vacancies', [
        'setVacancyProperty',
      ]),
      parseResponse(data) {
        this.items = data.data
        this.total = data.total
        this.perPage = data.per_page
      },
      onSortInput(value) {
        this.$router.push({query: {...this.$route.query, [this.otherKeys.SORT]: value}})
      },
      getOptionTextSort(key) {
        return this.$tVacancies('sort_' + key)
      },
      onDirectVacanciesInput(value) {
        this.$router.push({query: {...this.$route.query, direct_vacancies: value}})
      }
    },
  }


</script>

<style>

</style>
